module.exports = __webpack_public_path__ + "static/media/placeholder.39afe1f8.jpg";